import { ROUTE_PATH, OperationType } from "common/constants/sm-constants";
import { GridParams } from "common/models/utility-models/list-utility.model";
import { GridMetaModel, Headers } from "common/models/utility-models/meta-model";

export class TrainersViewGridMetaModel extends GridMetaModel<Headers> {
    constructor() {
      super(
        'Trainer View',
        ROUTE_PATH.trainersView,
        ROUTE_PATH.assignmentGrid,
        false,
        false,
        8,
        false,
        false,
        [],
        false,
        [],
        { isDownloadExcel: false, excelFileName: '', btnLabel: '', headers: [] },
        false,
        null,
        false,
        true
      );
    }
  
    prepareHeaderList(): Headers[] {
      const headers: Headers[] = [];
      const studentName = new Headers(
        'Student Name',
        'student_name',
        false,
        false,
        'text'
      );
      const attended = new Headers(
        'Attended (Y/N)',
        'attended',
        false,
        false,
        'text',
        '0',
        {
          isColumnNavigation: false,
          navigationUrl: '',
          navigateOperationType: null,
          navigateTransferData: null,
        },
        null,
        {
          isToggle: false,
          toggleKey: '',
          toggleCheckedValue: '',
          toggleUncheckedValue: '',
        }
      );
  
      const assignementFile = new Headers(
        'Assignment File',
        'display_filename',
        false,
        false,
        'text',
        '0',
        {
          isColumnNavigation: true,
          navigationUrl: ROUTE_PATH.reports,
          navigateOperationType: OperationType.VIEW,
          navigateTransferData: new GridParams(),
        }
      );
      const marks = new Headers('Marks', 'score', false, false, 'text', '0');
  
      const feedbackToAdmin = new Headers(
        'Feedback to Admin',
        'student_feedback',
        false,
        false,
        'text'
      );
      const feedbackFromStudent = new Headers(
        'Feedback from Student',
        'trainer_feedback_to_student',
        false,
        false,
        'text',
        '0'
      );
      const feedbackToStudent = new Headers(
        'Feedback To Student',
        'trainer_feedback_to_student',
        false,
        false,
        'text'
      );
      headers.push(studentName);
      headers.push(attended); 
      headers.push(assignementFile);
  
      headers.push(marks);
      headers.push(feedbackFromStudent);
      headers.push(feedbackToStudent);
      headers.push(feedbackToAdmin);
  
      return headers;
    }
  }
  